/*
 * @Description: Vuex 4 版本
 * @Author: 王天琦
 * @Date: 2022-06-08 08:46:50
 * @Updated: 2024 - Vue 3 升级
 */
import { createStore } from 'vuex'

export default createStore({
  state: {
    //上传excel文件编码与值的对应关系
    codeValues:[],
    arrnewuser: [
      {
        classify: "",
        value: "",
      }
    ], // 信息表
    arrpaifang: [], // 碳排放
    arrlicheng: [], // 历程
    arrranyou: [], // 燃油
    arrpinci: [], // 频次
    arrlaji: [], // 垃圾排放
    arrfadianliang: [], // 发电量
    arrdongtai: [], //动态数据
    lurushuju: {},
    flag: 1,
    active: 0,
    basicId: 46, //校园id
    cityData: [], //查找学校
    universityData: [], //查找城市
    classnone: true,
    buttonnew: false,
    fullscreenLoading: false, //查找城市
    codema: 200,
    flag1: 1,
    flag2: 1,
    flag3: 1,
    flag4: 1,
    flag5: 1,
    flag6: 1,
    flag8: 1,
    flag9: 1,
    flag10: 1,
    flag11: 1,
    flag12: 1,
    loginname: "",
    getpermission: [
      {
        id: 1,
        name: "首页",
        description: "",
      }
    ],
    rowObj: {}, //监听每行数据
    rowObj1: {}, //监听每行数据
    changeuniversity1: "",
    loginuniversity_code: 1,
    campus: "",
    loginid: 0,
    quanxianxinxi: 0,
    pdfid: 0,
    creator_id: 0,
    bData: [],
    fData: [],
    bDatac: [],
    fDatac: [],
    excelArrC: [],
    univerPropertyId: 0,
    cityCode: 0,
    univerCode: 0,
    univerPropertyIdc: 0,
    cityCodec: 0,
    univerCodec: 0,
    flagshuju: 0,
    sangjiname: {},
    sangjidata: [],
    sangjimiddle: [],
    shenhe: 0,
    shenheshuju: [],
    pdfuserid: 0,
    userFlag: 0,
    HomeUserName: "",
    HomeSchoolName: "",
    flagtotable: 0,
    flagtomanage: 0,
    chakan: 1,
    flagtohidden: 0,
    shezhi: false,
    token: "",
    expiretime: 0,
    buttoncode: 0,
    sangjiname1: {},
    sangjidata1: [],
    sangjimiddle1: [],
    campusstatus: 0,
    pdfshenhe: 0,
    loading1: false,
    checkFlag: false,
    buttonid: 0,
    //数据管理的基础数据
    verifyData: {},
    ityCodeUniversityCode: {},
    // JS/T 303-2026 标准页复用的完整已填充表格数据
    fullExcelArr: []
  },
  getters: {
    codeValues: (state) => state.codeValues,
    univerCodec:(state)=>state.univerCodec,
    univerPropertyIdc:(state)=>state.univerPropertyIdc,
    fDatac:(state)=>state.fDatac,
    bDatac:(state)=>state.bDatac,
    buttonid: (state) => state.buttonid,
    checkFlag: (state) => state.checkFlag,
    campusstatus: (state) => state.campusstatus,
    codema: (state) => state.codema,
    buttonnew: (state) => state.buttonnew,
    classnone: (state) => state.classnone,
    fullscreenLoading: (state) => state.fullscreenLoading,
    arrnewuser: (state) => state.arrnewuser,
    arrpaifang: (state) => state.arrpaifang,
    arrlicheng: (state) => state.arrlicheng,
    arrranyou: (state) => state.arrranyou,
    arrpinci: (state) => state.arrpinci,
    arrlaji: (state) => state.arrlaji,
    cityCodec: (state) => state.cityCodec,
    arrfadianliang: (state) => state.arrfadianliang,
    arrdongtai: (state) => state.arrdongtai,
    lurushuju: (state) => state.lurushuju,
    flag: (state) => state.flag,
    basicId: (state) => state.basicId,
    cityDataByCode: (state) => state.cityData,
    universityDataByCode: (state) => state.universityData,
    flag1: (state) => state.flag1,
    flag2: (state) => state.flag2,
    flag3: (state) => state.flag3,
    flag4: (state) => state.flag4,
    flag5: (state) => state.flag5,
    flag6: (state) => state.flag6,
    flag8: (state) => state.flag8,
    flag9: (state) => state.flag9,
    flag10: (state) => state.flag10,
    flag11: (state) => state.flag11,
    flag12: (state) => state.flag12,
    getpermission: (state) => state.getpermission,
    rowObj: (state) => state.rowObj,
    rowObj1: (state) => state.rowObj1,
    campus: (state) => state.campus,
    loginid: (state) => state.loginid,
    loginname: (state) => state.loginname,
    changeuniversity1: (state) => state.changeuniversity1,
    loginuniversity_code: (state) => state.loginuniversity_code,
    quanxianxinxi: (state) => state.quanxianxinxi,
    pdfid: (state) => state.pdfid,
    creator_id: (state) => state.creator_id,
    sangjiname: (state) => state.sangjiname,
    sangjidata: (state) => state.sangjidata,
    sangjimiddle: (state) => state.sangjimiddle,
    sangjiname1: (state) => state.sangjiname1,
    sangjidata1: (state) => state.sangjidata1,
    sangjimiddle1: (state) => state.sangjimiddle1,
    flagshuju: (state) => state.flagshuju,
    shenhe: (state) => state.shenhe,
    shenheshuju: (state) => state.shenheshuju,
    pdfuserid: (state) => state.pdfuserid,
    userFlag: (state) => state.userFlag,
    HomeUserName: (state) => state.HomeUserName,
    HomeSchoolName: (state) => state.HomeSchoolName,
    flagtotable: (state) => state.flagtotable,
    flagtomanage: (state) => state.flagtomanage,
    chakan: (state) => state.chakan,
    shezhi: (state) => state.shezhi,
    flagtohidden: (state) => state.flagtohidden,
    token: (state) => state.token,
    expiretime: (state) => state.expiretime,
    buttoncode: (state) => state.buttoncode,
    pdfshenhe: (state) => state.pdfshenhe,
    loading1: (state) => state.loading1,

    excelArrC: (state) => state.excelArrC,
    getVerifyData:(state) => state.verifyData,
    ityCodeUniversityCode:(state) => state.ityCodeUniversityCode,
    getFullExcelArr: (state) => state.fullExcelArr
  },
  mutations: {
    setCityCodeUniversityCode(state, data){
      state.ityCodeUniversityCode = data
    },
    updateCodeValues: (state, data) => {
      state.codeValues = data
    },
    loading1: (state, data) => {
      state.loading1 = data;
    },
    checkFlag: (state, data) => {
      state.checkFlag = data;
    },
    //
    ArrayTransmit1: (state, data) => {
      state.arrnewuser = data;
    },
    pdfshenhe: (state, data) => {
      state.pdfshenhe = data;
    },
    campusstatus: (state, data) => {
      state.campusstatus = data;
    },
    fullscreenLoading: (state, data) => {
      state.fullscreenLoading = data;
    },
    GetToken: (state, data) => {
      state.token = data;
    },
    Getexpiretime: (state, data) => {
      state.expiretime = data;
    },
    flagtotable: (state, data) => {
      state.flagtotable = state.flagtotable + data;
    },
    flagtomanage: (state, data) => {
      state.flagtomanage = state.flagtomanage + data;
    },
    ArrayTransmit2: (state, data) => {
      state.arrpaifang = data;
      state.arrpaifang.push("数组二");
    },
    buttoncode: (state, data) => {
      state.buttoncode = data;
    },
    ArrayTransmit3: (state, data) => {
      state.arrlicheng = data;
    },
    ArrayTransmit4: (state, data) => {
      state.arrranyou = data;
    },
    ArrayTransmit5: (state, data) => {
      state.arrpinci = data;
    },
    ArrayTransmit6: (state, data) => {
      state.arrlaji = data;
    },
    ArrayTransmit7: (state, data) => {
      state.arrfadianliang = data;
    },
    Arrdongtai: (state, data) => {
      if (data.length !== 0) {
        const lnData = data.find(item => item.classify === "LN")
        if(lnData && lnData.value.indexOf){
          if (lnData.value.indexOf("市") !== -1) {
            lnData.value = lnData.value.slice(0, lnData.value.indexOf("市"));
          }
        }
      }
      state.arrdongtai = data;
    },
    flagchange: (state, boon) => {
      state.flag = state.flag + boon;
    },
    shujuchange: (state, data) => {
      state.lurushuju = data;
    },
    shenhechange: (state, data) => {
      state.shenheshuju = data;
    },
    flag1change: (state, boon) => {
      state.flag1 = state.flag1 + boon;
    },
    flag2change: (state, boon) => {
      state.flag2 = state.flag2 + boon;
    },
    flag3change: (state, boon) => {
      state.flag3 = state.flag3 + boon;
    },
    flag4change: (state, boon) => {
      state.flag4 = state.flag4 + boon;
    },
    flag8change: (state, boon) => {
      state.flag8 = state.flag8 + boon;
    },
    flag9change: (state, boon) => {
      state.flag9 = state.flag9 + boon;
    },
    flag10change: (state, boon) => {
      state.flag10 = state.flag10 + boon;
    },
    flag11change: (state, boon) => {
      state.flag11 = state.flag11 + boon;
    },
    flag12change: (state, boon) => {
      state.flag12 = state.flag12 + boon;
    },
    flagquanxian: (state, boon) => {
      state.flag5 = state.flag5 + boon;
    },
    flagxiugaiquanxian: (state, boon) => {
      state.flag6 = state.flag6 + boon;
    },
    flagshujuxiugai: (state, boon) => {
      state.flagshuju = state.flagshuju + boon;
    },
    userFlag: (stata, data) => {
      stata.userFlag = data;
    },
    flagshenhe: (state, boon) => {
      state.shenhe = state.shenhe + boon;
    },
    add(state, index) {
      state.active = index;
    },
    addY(state) {
      state.active = 2;
    },
    addN(state) {
      state.active = 0;
    },
    addX(state) {
      state.active = 1;
    },
    add3(state) {
      state.active = 3;
    },
    addM(state) {
      state.active = -1;
    },
    saveBasicId(state, data) {
      state.basicId = data;
    },
    getcitycode: (state, data) => {
      state.cityData = data;
    },
    getuniversitycode: (state, data) => {
      state.universityData = data;
    },
    Getpermission: (state, data) => {
      if (data === null) {
        state.getpermission = [
          {
            description: "",
            id: 1,
            name: "首页",
          },
        ];
      } else {
        state.getpermission = data;
      }

      console.log("存储成功", state.getpermission);
    },
    getrowObj: (state, data) => {
      state.rowObj = data;
    },
    getrowObj1: (state, data) => {
      state.rowObj1 = data;
    },
    Loginuniversity_code: (state, data) => {
      state.loginuniversity_code = data;
    },
    changecups: (state, data) => {
      state.campus = data;
    },
    changeuniversity1: (state, data) => {
      state.changeuniversity1 = data;
    },
    Loginid: (state, data) => {
      state.loginid = data;
    },
    buttonid: (state, data) => {
      state.buttonid = data;
    },
    Loginname: (state, data) => {
      state.loginname = data;
    },
    quanxianxinxiid: (state, data) => {
      state.quanxianxinxi = data;
    },
    pdfid: (state, data) => {
      state.pdfid = data;
    },
    classnone: (state, data) => {
      state.classnone = data;
    },
    buttonnew: (state, data) => {
      state.buttonnew = data;
    },
    creator_id: (state, data) => {
      state.creator_id = data;
    },
    bData: (state, data) => {
      state.bData = data;
    },
    bData1: (state, data) => {
      state.bData = {};
    },
    fData: (state, data) => {
      state.fData = data;
    },
    fData1: (state, data) => {
      state.fData = {};
    },
    bDatac: (state, data) => {
      state.bDatac = data;
    },
    fDatac: (state, data) => {
      state.fDatac = data;
    },
    univerPropertyId: (state, data) => {
      state.univerPropertyId = data;
    },
    cityCode: (state, data) => {
      state.cityCode = data;
    },
    showshezhi: (state, bean) => {
      state.shezhi = bean;
    },
    univerCode: (state, data) => {
      state.univerCode = data;
    },
    univerPropertyIdc: (state, data) => {
      state.univerPropertyIdc = data;
    },
    cityCodec: (state, data) => {
      state.cityCodec = data;
    },
    codema: (state, data) => {
      state.codema = data;
    },
    univerCodec: (state, data) => {
      state.univerCodec = data;
    },
    getsangjinamepdf: (state, data) => {
      state.sangjiname = data;
    },
    getsangjidatapdf: (state, data) => {
      state.sangjidata = data;
    },
    getsangjimiddlepdf: (state, data) => {
      state.sangjimiddle = data;
    },
    getsangjinamepdf1: (state, data) => {
      state.sangjiname1 = data;
    },
    getsangjidatapdf1: (state, data) => {
      state.sangjidata1 = data;
    },
    getsangjimiddlepdf1: (state, data) => {
      state.sangjimiddle1 = data;
    },
    pdfuserid: (state, data) => {
      state.pdfuserid = data;
    },
    HomeSchoolName: (state, data) => {
      state.HomeSchoolName = data;
    },
    HomeUserName: (state, data) => {
      state.HomeUserName = data;
    },
    chakan: (state, data) => {
      state.chakan = data;
    },
    flagtohidden: (state, data) => {
      state.flagtohidden = state.flagtohidden + data;
    },

    excelArrC: (state, data) => {
      state.excelArrC = data
    },
    setVerifyData: (state, data) => {
      state.verifyData = data
    },
    setFullExcelArr: (state, data) => {
      state.fullExcelArr = data
    }
  },
  actions: {},
  modules: {},
});
